import { useMemo } from "react";

import { RouterProvider } from "react-router-dom";

import { UIConfigProvider } from "@regal-voice/ui";
import { icon as iconPath } from "Services/AssetManagementService";
import { isIframed } from "Services/embed/EmbedUtilService";
import { getLogger } from "Services/LoggingService";

import { usePageAvailability } from "../routes/Hooks/usePageAvilability/usePageAvailability";
import { configuredRouter } from "./appDataRouter";

export default function AppWithRouterAccess(): JSX.Element {
    const { liveOpsPages, convoIntelPages, orchestrationPages, aiAgentsPages } = usePageAvailability();

    const routerToUse = useMemo(
        () =>
            configuredRouter({
                convoIntelPages,
                liveOpsPages,
                orchestrationPages,
                aiAgentsPages,
            }),
        [liveOpsPages, convoIntelPages, orchestrationPages, aiAgentsPages]
    );

    return (
        <UIConfigProvider value={{ iconPath, getLogger, isIframed }}>
            <RouterProvider router={routerToUse} />
        </UIConfigProvider>
    );
}
